module.exports = __webpack_public_path__ + "image/header-pic4.png";